export default function Container({ children }) {
  return (
    <div className="w-full max-w-7xl mx-auto px-2 sm:px-3 lg:px-4">
      {children}
    </div>
  );
}
